import {
  openOverlay,
  OVERLAY_KEYS,
} from '../../packages/neb-lit-components/src/utils/overlay-constants';
import { BILLING_NOTE_TYPES } from '../../packages/neb-utils/constants';
import { parseDate } from '../../packages/neb-utils/date-util';

export const getDatesOfService = ({ dosFrom, dosTo }) => {
  let datesOfService = `${parseDate(dosFrom).format('MM/DD/YYYY')} - ${parseDate(dosTo).format('MM/DD/YYYY')}`;

  if (dosFrom === dosTo) {
    datesOfService = `${parseDate(dosFrom).format('MM/DD/YYYY')}`;
  }

  return datesOfService;
};

export const openClaimBillingNote = claim =>
  openOverlay(OVERLAY_KEYS.BILLING_NOTE, {
    parentType: BILLING_NOTE_TYPES.CLAIM,
    parentId: claim.id,
    parentData: {
      datesOfService: getDatesOfService(claim),
      claimNumber: claim.claimNumber,
      amount: claim.totalChargeAmount,
      payer: `${claim.insurancePayerAlias}, ${claim.insurancePlanName}`,
    },
    patientId: claim.patientId,
  });
